import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CurrentUserService } from '@core/services';
import { AppRoutes } from '@shared/enums';

export const userGuard: CanActivateFn = async () => {
    const router = inject(Router);
    const currentUserService = inject(CurrentUserService);

    const currentUser = await currentUserService.initializeCurrentUser();

    if (currentUser) {
        return true;
    }

    if (currentUser === null) {
        router.navigate([AppRoutes.ERROR_CURRENT_USER]);
        return false;
    }

    if (currentUser === undefined) {
        router.navigate([AppRoutes.UNAUTHORIZED]);
        return false;
    }

    router.navigate([AppRoutes.ERROR_CURRENT_USER]);
    return false;
};
